import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class HttpErrorHandler {
  constructor(private router: Router) {}

  handleHttpError(error) {
    switch (error.status) {
      case 500:
        this.router.navigate(['/error', 500]);
        return {};

      case 413:
        return (error.body['file'] = 'Archivo demasiado pesado, no debe superar los 4 MiB');

      case 404:
        this.router.navigate(['/error', 500]);
        return {};

      case 403:
        // remove user cookie
        localStorage.removeItem('currentUser');
        localStorage.removeItem('profile');
        window.location.href = '/login';
        return;

      case 401:
        this.router.navigate(['/error', 401]);
        return;

      case 400:
        return error.body;

      default:
        this.router.navigate(['/error', 500]);
        return {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/http-error-handler.ts